import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { Tab, Tabs, TabPanel } from '@redshelf/redshelf-ui';
import { ShareNotes } from 'components/Collaboration';

import { SCREEN_SIZE_CATEGORIES } from 'constants';
import { NetworkStatusValuesContext, ViewportValuesContext } from 'contexts';
import {
  CollaborationOfflineMessage,
  ViewAndSubscribe,
} from 'components/Collaboration';

const useStyles = makeStyles((theme) => ({
  root: {},
  tab: {
    margin: 0,
    paddingLeft: theme.spacing(4.5),
    paddingRight: theme.spacing(4.5),
  },
  tabPanel: {
    maxHeight: 'calc(100vh - 211px)', // stop just above the scrub bar (title/tabs + topbar + scrubbar)

    [theme.breakpoints.down('sm')]: {
      maxHeight: '100vh', // tab height
    },

    '&.MuiTabPanel-spacing': {
      padding: 0,
      margin: 0,
    },
  },
}));

const CollaborationMenu = ({ className, ...props }) => {
  const classes = useStyles();

  const { isOffline } = useContext(NetworkStatusValuesContext);
  const { viewport } = useContext(ViewportValuesContext);

  const [activeTabId, setActiveTabId] = useState(0);
  const handleTabOnChange = (event, newValue) => {
    setActiveTabId(newValue);
  };

  return isOffline ? (
    <CollaborationOfflineMessage {...props} />
  ) : (
    <>
      <Tabs
        aria-label="collaboration-menu-tabs"
        onChange={handleTabOnChange}
        value={activeTabId}
        className={clsx(classes.root, className)}
        selectionFollowsFocus={true}
        variant={
          viewport.widthCategory === SCREEN_SIZE_CATEGORIES.PHONE
            ? 'fullWidth'
            : null
        }
        {...props}
      >
        <Tab className={classes.tab} label="Share Notes" wrapped />
        <Tab className={classes.tab} label="View and Subscribe" wrapped />
      </Tabs>

      <TabPanel className={classes.tabPanel} value={activeTabId} index={0}>
        <ShareNotes />
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={activeTabId} index={1}>
        <ViewAndSubscribe />
      </TabPanel>
    </>
  );
};

CollaborationMenu.propTypes = {
  className: PropTypes.string,
};

export default CollaborationMenu;
